// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"e91e413c","174":"506db399","734":"3b32c8b7","852":"b0a73b58"}[chunkId] + ".js";
};